// src/utils/upload/imageUploadHelpers.js

import toast from "react-hot-toast";

/**
 * ✅ Generate unique temporary ID
 */
export const generateTempId = () => {
    return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * ✅ Check if can add more images
 */
export const canAddMoreImages = (currentCount, uploadingCount, maxImages) => {
    return currentCount + uploadingCount < maxImages;
};

/**
 * ✅ Get remaining slots
 */
export const getRemainingSlots = (currentCount, uploadingCount, maxImages) => {
    return Math.max(0, maxImages - currentCount - uploadingCount);
};

/**
 * ✅ Show max images error
 */
export const showMaxImagesError = (maxImages, isArabic) => {
    toast.error(
        isArabic
            ? `الحد الأقصى ${maxImages} صور`
            : `Maximum ${maxImages} images allowed`,
        { duration: 3000 }
    );
};

/**
 * ✅ Show files added success
 */
export const showFilesAddedSuccess = (count, isArabic) => {
    toast.success(
        isArabic
            ? `تم إضافة ${count} ${count === 1 ? 'صورة' : 'صور'} للرفع`
            : `${count} image${count > 1 ? 's' : ''} added to upload queue`,
        { duration: 2000 }
    );
};

/**
 * ✅ Show upload success
 */
export const showUploadSuccess = (isArabic) => {
    toast.success(
        isArabic ? 'تم رفع الصورة بنجاح' : 'Image uploaded successfully',
        { duration: 2000 }
    );
};

/**
 * ✅ Show upload error
 */
export const showUploadError = (errorMsg, isArabic) => {
    const message = errorMsg || (isArabic ? "فشل رفع الصورة" : "Upload failed");
    toast.error(message, { duration: 4000 });
};

/**
 * ✅ Show delete success
 */
export const showDeleteSuccess = (isArabic) => {
    toast.success(
        isArabic ? 'تم حذف الصورة' : 'Image deleted',
        { duration: 2000 }
    );
};

/**
 * ✅ Show retry message
 */
export const showRetryMessage = (isArabic) => {
    toast.success(
        isArabic ? 'إعادة محاولة الرفع...' : 'Retrying upload...',
        { duration: 2000 }
    );
};

/**
 * ✅ Show validation error
 */
export const showValidationError = (validation, isArabic) => {
    toast.error(
        isArabic ? validation.errorAr : validation.error,
        { duration: 4000 }
    );
};

/**
 * ✅ Show rejected files error
 */
export const showRejectedFilesError = (rejectedFiles, isArabic) => {
    rejectedFiles.forEach((rejection) => {
        const errors = rejection.errors.map(e => e.message).join(', ');
        toast.error(
            isArabic ? `ملف غير صالح: ${errors}` : `Invalid file: ${errors}`,
            { duration: 4000 }
        );
    });
};

/**
 * ✅ Create uploaded image object
 */
export const createUploadedImageObject = (response, compressedFile) => {
    return {
        id: response?.data?.id || null,
        file_name: response?.data?.file_name || response?.data?.name || "",
        url: response?.data?.url || response?.data?.preview || "",
        preview: URL.createObjectURL(compressedFile),
    };
};

/**
 * ✅ Extract error message from response
 */
export const extractErrorMessage = (error, isArabic) => {
    return error?.response?.data?.message ||
        error?.message ||
        (isArabic ? "فشل رفع الصورة" : "Upload failed");
};
